import React, { useRef, useState, useEffect } from 'react';
import confirm from '../forms/confirm';
import { addAttachment, removeAttachment } from "../redux/actions/enrollments-actions";
import { useDispatch, useSelector } from "react-redux";
import { TrashCan16 } from '@carbon/icons-react';
import useMsalApi from "./use-msal-api";
import { Button } from 'carbon-components-react';
import FormFileUploader from './form_elements/form-file-uploader';
import { FileExists } from './attachment-validator';

const Attachment = ({show, attachmentType, name, buttonLabel, labelDescription, label, attachments, setAttachments, uploadOnChange}) => {
    const linkRef = useRef(null);
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
    const [file, setFile] = useState();
    const enrollments = useSelector(s => s.enrollments);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (Array.isArray(enrollments)) 
            return;

        setFile(FileExists(enrollments, attachmentType));

    }, [enrollments]);

    const change = async (e) => {
        const attachment = {
            file: e.target.files.item(0),
            type: attachmentType
        }
        setAttachments(attachments.concat([attachment]))
        if(uploadOnChange && uploadOnChange === true){
            setSubmitting(true);
            const frmData = new FormData();
            frmData.append("file", e.target.files.item(0));

            const uploadResult = await callApi(`Attachment/${enrollments.id}/${attachmentType}`, "POST", frmData, "multipart/form-data");
            if(!uploadResult.error){
                dispatch(addAttachment(uploadResult));
            }
            setSubmitting(false);

        }

    }

    const remove = (e) => {
        console.log("removing attachment");
        setAttachments(attachments.filter(s => s.type !== attachmentType));
    }

    const downloadFile = async (id, name, contentType) => {

        var result = await confirm(`Download ${name}?`, {title: "Download file?", buttonText: "Download"});
        if(result){
            var blob = await callApi(`Attachment/${id}`, "GET", null, contentType, true); 
            const href = window.URL.createObjectURL(new Blob([blob]));
            const a = linkRef.current;        
            a.download = name;
            a.href = href;
            a.click();
            a.href = '';
        }
    }

    const deleteFile = async (id, name, attachmentCategory) => {

        var confirmation = await confirm(`Delete ${name}?`, {title: "Delete file?", buttonText: "Delete"});
        if(confirmation){
            var result = await callApi(`Attachment/${id}`, "DELETE"); 
            if(!result.error){
                dispatch(removeAttachment(attachmentCategory));
                setFile(null);
            }
        }
    }

    return ( 
        <>
        {show ? 
            <>
                {file ?
                <div className='mt-2'>
                    <Button kind="ghost" size="sm" onClick={() => downloadFile(file.id, file.fileName, file.contentType)}>
                    {file.fileName}
                    </Button>

                    <Button hasIconOnly iconDescription={`Remove ${file.fileName}`} kind="ghost" size="sm" onClick={() => {deleteFile(file.id, file.fileName, file.enrollmentAttachmentTypeId)}}>
                        <TrashCan16 />
                    </Button>
                    <a ref={linkRef}/>
                </div> :
                <>
                        <FormFileUploader
                            name={name} accept={['.pdf']} 
                            buttonLabel={buttonLabel} 
                            labelDescription={labelDescription} 
                            label={label}
                            onChange={change}
                            onDelete={remove}
                            disabled={submitting}
                        />

                
                </>
                }
            </>
        :
            <></>
        }
        </>
     );
}
 
export default Attachment;